<div class="item-page-field">
  <div class="simple-view-element form-group" >
    <span class="simple-view-element-header h3" *ngIf="label">{{ label|translate }}</span>
    <div  class="simple-view-element-body">
          <span>{{ value }} </span>
    </div>
  </div>
</div>
